import { Component, OnInit } from '@angular/core';
import {
  SelectedCustomerService,
  Customer,
  CustomerService,
  CustomerContactService,
  GungFlowService,
  AuthService,
  CartService,
  AvailabilityService,
  CustomerContact,
  GungFlow,
  CartRow
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { AssignJeevesDefaultsComponent, JeevesDeliveryAddressesService } from 'gung-standard-jeeves';

@Component({
    selector: 'tylo-tylo-assign-jeeves-defaults',
    templateUrl: './tylo-assign-jeeves-defaults.component.html',
    styleUrls: ['./tylo-assign-jeeves-defaults.component.css'],
    standalone: false
})
export class TyloAssignJeevesDefaultsComponent extends AssignJeevesDefaultsComponent implements OnInit {
  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected customerContactService: CustomerContactService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected availabilityService: AvailabilityService,
    protected dateUtilService: DateUtilService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService
  ) {
    super(
      selectedCustomerService,
      customerService,
      customerContactService,
      gungFlowService,
      authService,
      cartService,
      availabilityService,
      dateUtilService,
      jeevesDeliveryAddressesService
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected setValues(
    customer: Customer,
    flow: GungFlow,
    user,
    customerContacts: CustomerContact[],
    billingCustomer?: Customer,
    cartRows?: CartRow[]
  ) {
    super.setValues(customer, flow, user, customerContacts, billingCustomer, cartRows);

    this.checkout.extra.procargs.ordlevadr1 = customer.name;
    this.checkout.extra.procargs.ftgpostnr = customer.extra.fr.ftglevpostnr || customer.extra.fr.ftgpostnr;
    this.checkout.extra.procargs.ordlevadr3 = customer.extra.fr.ftgpostadr5 || this.checkout.extra.procargs.ordlevadr3;

    const postalCity = customer.extra.fr.ftgpostlevadr3 || this.checkout.extra.procargs.ordlevadr4;
    const postalCode = this.checkout.extra.procargs.ftgpostnr;
    this.checkout.extra.procargs.ordlevadr4 = postalCity + ' ' + postalCode;

    this.checkout.extra.oh.kundref2 = user.email;

    this.checkout.extra.procargs.levsattkod = customer.extra.kus.levsattkod;
  }
}
